import { memo } from "react";
import { Dropdown } from "react-bootstrap";


const BzDropdown = ({ className, ...props }) => {
    return (
        <Dropdown className={className} {...props}>
            {props.children}
        </Dropdown>
    )
}

export default memo(BzDropdown);